import { Routes, Route } from "react-router-dom";

import WarehouseAllocationListScreen from "screens/App/CRM/WarehouseAllocation/WarehouseAllocationListScreen";
import WarehouseAllocationInfoScreen from "screens/App/CRM/WarehouseAllocation/WarehouseAllocationInfoScreen";
import WarehouseAllocationDetailScreen from "screens/App/CRM/WarehouseAllocation/WarehouseAllocationDetailScreen";
import WarehouseAllocationEditScreen from "screens/App/CRM/WarehouseAllocation/WarehouseAllocationEditScreen";
import WarehouseAllocationCreateScreen from "screens/App/CRM/WarehouseAllocation/WarehouseAllocationCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const WarehouseAllocationRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<WarehouseAllocationListScreen />} />
      <Route path="create" element={<WarehouseAllocationCreateScreen />} />
      <Route path=":id/detail" element={<WarehouseAllocationDetailScreen />} />
      <Route path=":id/edit" element={<WarehouseAllocationEditScreen />} />
      <Route path="info" element={<WarehouseAllocationInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default WarehouseAllocationRouter;
